import { MarketingSuppressionReason } from "@redotech/redo-marketing-common/suppression/marketing-suppression-zod-schema";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const getCustomerSuppressionInfo = {
  name: "getCustomerSuppressionInfo" as const,
  input: z.object({ customerId: z.string() }),
  output: z.object({
    emailSuppressionReasons: z.array(createEnum(MarketingSuppressionReason)),
    smsSuppressionReasons: z.array(createEnum(MarketingSuppressionReason)),
  }),
};
